import React from "react";
import { Wrapper } from "./style";
import Com1 from "./components/Com1";
import Com2 from "./components/Com2";
import Com3 from "./components/Com3";
import DesignCom from "./components/DesignCom";
import ComingSoon from "pages/ComingSoon";
const Nft = () => {
  return (
    <Wrapper>
      <ComingSoon imgPath="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/2afe84a5NFT_1.svg" />
      {/* <Com1 />
      <Com2 />
      <Com3 />
      <DesignCom /> */}
    </Wrapper>
  );
};

export default Nft;
